<template>
    <div class="loginContainer">
        <div class="topTitleBox">
            <img src="@/assets/img/kx_logo.png" alt="">
            <span>新媒体事业部消耗表系统</span>
        </div>
        <div class="content">
            <h3>登录</h3>
            <div v-loading='loading'>
                <div class="inputItem">
                    <p>用户名</p>
                    <el-input
                        class="input"
                        placeholder="请输入用户名"
                        v-model.trim="userName"
                        clearable>
                    </el-input>
                </div>
                <div class="inputItem">
                    <p>密码</p>
                    <el-input
                        class="input"
                        placeholder="请输入密码"
                        v-model.trim="password"
                        @keydown.native.enter="loginEvent()"
                        show-password
                        >
                    </el-input>
                </div>
                <button class="loginButton" @click="loginEvent">登录</button>
            </div>
            <p class="loginHine">
                如忘记密码，请询问管理员找回密码
            </p>
        </div>
    </div>
</template>
<script>
import permissionInit from '@/router/permission.js'
import md5 from 'md5';
export default {
    components:{
    },
    data(){
        return{
            userName:'',
            password:'',
            loading:false
        }
    },
    methods:{
        loginEvent(){
            this.$message.closeAll()
            if(this.userName==''){
                this.$message({
                    message: '请输入用户名',
                    type: 'error'
                })
                return;
            }
            if(this.password==''){
                this.$message({
                    message: '请输入密码',
                    type: 'error'
                })
                return;
            }
            this.loading = true;
            this.$axios.post(this.URL.BASEURL + this.URL.Login,{
                    "username": this.userName,
                    "password": this.password
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    var userInfo = {
                        'admin_id': res.rst.admin_id,
                        'username': res.rst.username,
                        'role_id': res.rst.role_id,
                        'role_name': res.rst.role_name,
                        'real_name': res.rst.real_name,
                        'phone': res.rst.phone,
                        'ttl': res.rst.ttl,
                        'sign': md5("random="+res.rst.random+"&ttl="+res.rst.ttl+"&user_id="+res.rst.admin_id)
                    }
                    this.$cookie.setCookie('userInfo',JSON.stringify(userInfo))
                    this.$cookie.setCookie('isLogin',true)
                    permissionInit(()=>{
                        this.$router.push('/home')
                    })
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.loginContainer{
    width: 100%;
    min-height: 100vh;
    background: url('../../assets/img/loginBg.png') no-repeat;
    background-size:100% 100%;
    .topTitleBox{
        text-align: center;
        padding-top: 46px;
        img{
            display: inline-block;
            height: 43px;
            vertical-align: middle;
        }
        span{
            color: #FFFFFF;
            font-size: 29px;
            line-height: 40px;
            display: inline-block;
            margin-left: 12px;
            &::before{
                content: '';
                display: inline-block;
                width: 2px;
                height: 28px;
                background: #FFFFFF;
                vertical-align: middle;
                margin-right: 12px;
                margin-top: -3px;
            }
        }
    }
    .content{
        width: 399px;
        background: #FFFFFF;
        padding: 20px 30px 40px;
        border-radius: 6px;
        margin: auto;
        margin-top: 100px;
        h3{
            color: #02043C;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            margin-bottom: 24px;
        }
        .inputItem{
            margin-bottom: 20px;
            p{
                color: #666666;
                font-size: 12px;
                line-height: 17px;
            }
            .input{
                width: 100%;
                height: 40px;
                border-radius: 4px;
                font-size: 13px;
                margin-top: 5px;
            }
        }
        .loginButton{
            width: 100%;
            height: 40px;
            background: #5B7BFE;
            border-radius: 2px;
            color:#FFFFFF;
            font-size: 13px;
            border: none;
            margin-top: 20px;
        }
        .loginHine{
            color:#010235;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            margin-top: 30px;
            span{
                color: #5B7BFE;
                font-weight: 500;
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Login/index.vue